import React, { JSX } from "react";
import HeroContainer from "../../shared/widgets/container/HeroContainer";
import GridContainer from "../../shared/widgets/container/GridContainer";
import GridContainerItem from "../../shared/widgets/container/GridContainerItem";
import logo from "../../shared/images/logo.png";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export const PromptUser = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <HeroContainer maxWidth={"sm"}>
      <GridContainer>
        <GridContainerItem xs={12} justifyContent={"center"}>
          <img src={logo} alt="logo" width={255} height={150} />
        </GridContainerItem>
        <GridContainerItem xs={12} justifyContent="center">
          <Box mt={6}>
            <Typography>{t("profile.activation.promp")}</Typography>
          </Box>
        </GridContainerItem>
      </GridContainer>
    </HeroContainer>
  );
};
